const NEXTROLL_STYLE_ID = "ionet-nextroll-disabled";

export const isNextrollEnabled = () => import.meta.env.VITE_APP_NEXTROLL_ENABLED === "true";

/**
 * NextRoll (AdRoll) consent UI is injected via GTM. When disabled, opt out before the pixel
 * runs and hide any banner DOM that still mounts.
 */
export const applyNextrollPolicy = () => {
  if (isNextrollEnabled()) {
    return;
  }

  const w = window as Window & {
    adroll_optout?: boolean;
    dataLayer?: Record<string, unknown>[];
  };

  w.adroll_optout = true;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ nextroll_enabled: false });

  if (document.getElementById(NEXTROLL_STYLE_ID)) {
    return;
  }

  const style = document.createElement("style");
  style.id = NEXTROLL_STYLE_ID;
  style.textContent = `
    #nextroll_consent_persistent_icon,
    #nextroll_consent_banner,
    [id^="nextroll_consent"] {
      display: none !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);

  const hideNextrollNodes = () => {
    document
      .querySelectorAll<HTMLElement>(
        "#nextroll_consent_persistent_icon, #nextroll_consent_banner, [id^='nextroll_consent']"
      )
      .forEach((el) => {
        el.remove();
      });
  };

  hideNextrollNodes();

  const observer = new MutationObserver(hideNextrollNodes);
  observer.observe(document.documentElement, { childList: true, subtree: true });
};
